// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"skeleton_wrapper__3IN8b","sidebar":"skeleton_sidebar__3KNyx","logo":"skeleton_logo__qtE9x"};